/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { IDmpConfiguration } from "@almamedia/amr-adtech-stack/lib/services/dmp/almadmp";
import { ICustomVariables } from "../data-layer/data-layer";
import { StackContext } from "../context";
import { SiteNativeTemplate } from "../native/native";

const dmp: IDmpConfiguration<ICustomVariables, SiteNativeTemplate> = {
  enabled: true,
  siteId: "seoqgtwqb",
  defaults: { collectOnPageLoad: false },
  customProps: {
    page: [
      {
        name: "talent_tags",
        resolve: (context: StackContext) => {
          return context.services.dataLayerService?.dataLayer.pageTags;
        },
      },
    ],
  },
};

export default dmp;
